"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getFileNameFromURL = void 0;

var _isEmptyString = _interopRequireDefault(require("../object/isEmptyString"));

var getFileNameFromURL = function getFileNameFromURL(url) {
  var defaultFileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';
  if ((0, _isEmptyString["default"])(url)) return defaultFileName;
  return url.split('/').pop().split('#')[0].split('?')[0];
};

exports.getFileNameFromURL = getFileNameFromURL;
var _default = getFileNameFromURL;
exports["default"] = _default;